import React from "react";
import {Button, CardActions, CardContent, CardHeader, Alert} from "@mui/material";
import {useState} from "react";
import {useDispatch} from "react-redux";
import {deleteUser} from "../../index";
import DialogContentText from "@mui/material/DialogContentText";
import {setModal} from "../../../../Common/App";
import {DialogCard, Loader} from "../../../../../Components";

export const DeleteUser = ({id}) => {

    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [status, setStatus] = useState("info");

    const handleSubmit = async () => {
        if (!id) {
            setMessage('User information is missing. Please close and try again.');
            setStatus('error');
            return;
        }

        setIsLoading(true);
        setMessage('');
        await deleteUser({dispatch, data:{id: id || ''}}).then((res) => {
            if(res.success){
                dispatch(setModal({component:null, open:false}));
            }
            setIsLoading(false);
            setMessage(res.message || '');
            setStatus(res.status || 'error');
        });
    };

    return(
        <DialogCard>
            <CardHeader
                title={"Delete User"}
                avatar={<Loader isLoading={isLoading} type={"linear"}/>}
            />
            <CardContent sx={{ p: 2, pt:2 }}>
                <DialogContentText sx={{ mb: 2 }}>
                    Are you sure you want to delete this user? This action cannot be undone. The user will be permanently removed from the system.
                </DialogContentText>
                {message && (
                    <Alert severity={status === 'error' ? 'error' : 'info'} sx={{ mt: 2 }}>
                        {message}
                    </Alert>
                )}
            </CardContent>
            <CardActions>
                <Button variant={"outlined"} onClick={() => dispatch(setModal({component:null, open:false}))}>Cancel</Button>
                <Button disabled={isLoading} variant="contained" color={'error'} onClick={ handleSubmit }>Delete User</Button>
            </CardActions>
        </DialogCard>
    )
}